export const body = {
    paddingTop: "20px",
    paddingRight: "30px"
};

export const uploadView = {
    display: "flex",
    flexDirection: "row",
    alignItems: "center"
};

export const filesTableRow = {
    padding: "5px"
};

export const filesTableheading = {
    color: "red"
};

export const errorModalColor = {
    color: "red"
};

export const successModalColor = {
    color: "green"
};

export const columnPadding = {
    padding: "5px"
};
